"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDatePicker = void 0;
var date_fns_1 = require("date-fns");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
require("../../../index.css");
var InputDatePicker = /** @class */ (function (_super) {
    __extends(InputDatePicker, _super);
    function InputDatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: "",
        };
        _this.setAsyncState = function (newState) {
            return new Promise(function (resolve) { return _this.setState(newState, resolve); });
        };
        _this.handleCellOnBlur = function () {
            setTimeout(function () {
                var _a, _b;
                if (((_a = _this.props.cellInput) === null || _a === void 0 ? void 0 : _a.active) && _this.props.cellInput.onBlur) {
                    (_b = _this.props.cellInput) === null || _b === void 0 ? void 0 : _b.onBlur();
                }
            }, 250);
        };
        _this.handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var testCond, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        testCond = false;
                        error = "Please select a date";
                        if (!this.props.optional) {
                            if (this.props.range) {
                                if (this.props.startDate &&
                                    this.props.endDate &&
                                    (0, moment_1.default)(this.props.startDate).isAfter((0, moment_1.default)(this.props.endDate))) {
                                    if (this.props.showTime)
                                        error = "Please select a proper date and time range";
                                    else
                                        error = "Please select a proper date range";
                                }
                                else {
                                    testCond = true;
                                }
                            }
                            else {
                                if (this.props.value instanceof Date) {
                                    testCond = true;
                                }
                            }
                        }
                        else {
                            testCond = true;
                        }
                        if (!!testCond) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setAsyncState({ error: error })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.setAsyncState({ error: "" })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, testCond];
                }
            });
        }); };
        _this.handleFilter = function (date) {
            if (_this.props.filterDate) {
                var isDay_1 = false;
                _this.props.filterDate.map(function (eachDay) {
                    if ((0, date_fns_1.getDay)(date) === eachDay) {
                        isDay_1 = true;
                    }
                    return null;
                });
                return isDay_1;
            }
            else {
                return true;
            }
        };
        _this.renderContent = function () {
            var _a;
            var dateFormat = _this.props.showTime ? "dd/MM/yy h:mm aa" : "dd/MM/yy";
            var popperClassName = _this.props.staticDropdown && "!static";
            if (_this.props.range) {
                return (react_1.default.createElement("div", { className: "grid grid-cols-2" },
                    react_1.default.createElement("div", { className: "mr-2" },
                        react_1.default.createElement("div", { className: "font-medium text-sm mb-1" }, "Start Date"),
                        react_1.default.createElement(react_datepicker_1.default, { id: _this.props.id, dateFormat: dateFormat, selected: _this.props.startDate, onChange: function (date) {
                                var _a, _b;
                                if (_this.props.startDate &&
                                    (0, moment_1.default)(date).isSame(_this.props.startDate))
                                    _this.props.onChange((_a = _this.props.id) !== null && _a !== void 0 ? _a : "", undefined, "start");
                                else
                                    _this.props.onChange((_b = _this.props.id) !== null && _b !== void 0 ? _b : "", date, "start");
                            }, selectsStart: true, showTimeSelect: _this.props.showTime, timeFormat: "h:mm aa", timeIntervals: 5, timeCaption: "time", minDate: _this.props.minDate, maxDate: _this.props.endDate, startDate: _this.props.startDate, endDate: _this.props.endDate, nextMonthButtonLabel: ">", previousMonthButtonLabel: "<", disabled: _this.props.disabled, filterDate: _this.handleFilter, popperClassName: popperClassName })),
                    react_1.default.createElement("div", { className: "ml-2" },
                        react_1.default.createElement("div", { className: "font-medium text-sm mb-1" }, "End Date"),
                        react_1.default.createElement(react_datepicker_1.default, { id: _this.props.id, dateFormat: dateFormat, selected: _this.props.endDate, onChange: function (date) {
                                var _a, _b;
                                if (_this.props.endDate &&
                                    (0, moment_1.default)(date).isSame(_this.props.endDate))
                                    _this.props.onChange((_a = _this.props.id) !== null && _a !== void 0 ? _a : "", undefined, "end");
                                else
                                    _this.props.onChange((_b = _this.props.id) !== null && _b !== void 0 ? _b : "", date, "end");
                            }, selectsEnd: true, showTimeSelect: _this.props.showTime, timeFormat: "h:mm aa", timeIntervals: 5, timeCaption: "time", minDate: _this.props.startDate, maxDate: _this.props.maxDate, startDate: _this.props.startDate, endDate: _this.props.endDate, nextMonthButtonLabel: ">", previousMonthButtonLabel: "<", disabled: _this.props.disabled, filterDate: _this.handleFilter, popperClassName: popperClassName }))));
            }
            else {
                return (react_1.default.createElement(react_datepicker_1.default, { id: _this.props.id, className: "".concat(((_a = _this.props.cellInput) === null || _a === void 0 ? void 0 : _a.active) &&
                        "react-datepicker-small react-datepicker-borderless", " ").concat(_this.state.error.length > 0 && "react-datepicker-error"), dateFormat: dateFormat, selected: _this.props.value, onChange: function (date) {
                        var _a, _b;
                        if (_this.props.value && (0, moment_1.default)(date).isSame(_this.props.value))
                            _this.props.onChange((_a = _this.props.id) !== null && _a !== void 0 ? _a : "", undefined);
                        else
                            _this.props.onChange((_b = _this.props.id) !== null && _b !== void 0 ? _b : "", date);
                    }, selectsStart: true, showTimeSelect: _this.props.showTime, timeFormat: "h:mm aa", timeIntervals: 5, timeCaption: "time", minDate: _this.props.minDate, maxDate: _this.props.maxDate, nextMonthButtonLabel: ">", previousMonthButtonLabel: "<", disabled: _this.props.disabled, autoFocus: _this.props.autoFocus, filterDate: _this.handleFilter, onBlur: _this.handleCellOnBlur.bind(false), popperClassName: popperClassName }));
            }
        };
        return _this;
    }
    InputDatePicker.prototype.render = function () {
        var _a;
        return (react_1.default.createElement("div", { className: "w-full ".concat(this.props.className) },
            react_1.default.createElement("div", { className: "relative" },
                react_1.default.createElement("label", { className: "block mb-1 text-sm font-medium text-gray-700" },
                    !this.props.range && ((_a = this.props.title) !== null && _a !== void 0 ? _a : "Select Date"),
                    this.props.labelExtra),
                this.renderContent(),
                react_1.default.createElement("span", { className: "text-red-500 text-sm" }, this.state.error))));
    };
    return InputDatePicker;
}(react_1.Component));
exports.InputDatePicker = InputDatePicker;
//# sourceMappingURL=index.js.map